"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireDefault(require("react"));
var _PaginationItem = _interopRequireDefault(require("@mui/lab/PaginationItem"));
var _Pagination = _interopRequireDefault(require("@mui/material/Pagination"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    paginationItem: {
      backgroundColor: "transparent",
      color: theme.palette.neutral.dark,
      fontWeight: theme.typography.fontWeightRegular,
      '&:hover': {
        backgroundColor: theme.palette.neutral.main,
        color: theme.palette.neutral.contrastText,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    paginationItemActive: {
      backgroundColor: "".concat(theme.palette.primary.main, " !important"),
      color: theme.palette.primary.contrastText,
      fontWeight: theme.typography.fontWeightMedium
    }
  };
});
var HiPagination = function HiPagination(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Pagination.default, (0, _extends2.default)({
    renderItem: function renderItem(item) {
      return /*#__PURE__*/_react.default.createElement(_PaginationItem.default, (0, _extends2.default)({
        classes: {
          root: classes.paginationItem,
          selected: classes.paginationItemActive
        }
      }, item));
    }
  }, props));
};
var _default = exports.default = HiPagination;